import { motion } from "framer-motion";
import { Overline } from "@/components/Reveal";

// Shared inner-page hero header.
export default function PageHeader({ overline, title, sub, image }) {
  return (
    <section className="relative pt-40 pb-20 md:pt-52 md:pb-28 overflow-hidden" data-testid="page-header">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" fetchPriority="high" decoding="async" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-[var(--tx-bg)]/70 via-[var(--tx-bg)]/60 to-[var(--tx-bg)]" />
        </div>
      )}
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <Overline>{overline}</Overline>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 font-display font-light tracking-tight text-5xl sm:text-6xl lg:text-8xl leading-[0.95] max-w-4xl"
        >
          {title}
        </motion.h1>
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.25 }}
            className="mt-8 max-w-2xl text-lg text-[var(--tx-text-2)] leading-relaxed"
          >
            {sub}
          </motion.p>
        )}
      </div>
    </section>
  );
}
